export const ruleArrayMinLength = (minLength: number) => ({
  validator: (_: unknown, value: unknown[]): Promise<void> => {
    if (value && value.length < minLength) {
      return Promise.reject(Error(`Минимальное количество: ${minLength}`));
    }
    return Promise.resolve();
  },
});
